/**
 * 查询题目数量
 * @description 查询题目数量
 * @author hxliu
 * @date 2020-3-27
 */
 import React from 'react';
 import { connect } from 'dva';
 
 import { framework_tool, component_tool, utils_tool } from '@/tool';
 import PropTypes from 'prop-types'
 let { WizContainer } = framework_tool
 import { ExamPreview } from '../../../../components'
 import { modelUtils } from '@/utils';
 let { Session } = utils_tool;
 let { WizUpload, WizIcon, WizButton,WizTypography } = component_tool;
 const { Text } = WizTypography;
 import { Spin } from 'antd'
 
 
 class QueryQuestionCount extends WizContainer {
 
     componentName = 'QueryQuestionCount';
 
     constructor(props) {
         super(props);
         this.state = {
             count: 0
         }
     }
 
     static propTypes = {
         count: PropTypes.number,
         changeCount: PropTypes.func,
     }
 
     _componentDidMount() {
         this._reload(this.props);
     }
 
     propsAndStateOnChange = {
         questionCategory: this._reload.bind(this),
         type: this._reload.bind(this),
         difficulty: this._reload.bind(this),
         questionCount: this._questionCount.bind(this),
     };
     _questionCount(nextProps, nextState) {
         let { questionCount } = nextProps
         if (questionCount && questionCount['success']) {
             nextState['count'] = questionCount['data']
             this.props.changeCount && this.props.changeCount(questionCount['data'])
             return true
         } else {
             return false
         }
     }
     _reload(nextProps, nextState) {
         const { questionCategory, type, difficulty } = nextProps
         let params = {}
         if (questionCategory && questionCategory instanceof Array && questionCategory.length > 0) {
             params = { ...params, id: questionCategory[0]['key'] }
         }
         if (type === 0 || type) {
             params = { ...params, type: type }
         }
         if (difficulty === 0 || difficulty) {
             params = { ...params, difficulty: difficulty }
 
         }
         this.doActions([
             {
                 path: 'bankQuestion/queryCount',
                 payload: {
                     key: 'queryCountKey',
                     apiParams: {
                         ...params
                     }
                 }
             },
         ]);
         return false;
     }
     _render() {
         const { questionCategory, type, difficulty } = this.props
         const { count } = this.state
         return (
                 <div>
                     <Text
                         strong>该分类中符合条件共{count}题 </Text>
                 </div>
         );
     }
 }
 
 const mapStateToProps = (state, ownProps) => {
     const { bankQuestion } = state;
     const questionCount = modelUtils.getModelEntity(bankQuestion, "queryCountKey");
     // const load = modelUtils.getLoadingState(state, ['bankQustion']);
     return {
         questionCount,
         //  ...load
     };
 };
 
 export default connect(mapStateToProps)(QueryQuestionCount);
 